<template>
    <div class="patient_condition">
        <KvTable :items="getPatientStatus"/>
    </div>
</template>

<script>
    import KvTable from '@/components/Table/kvTable';
    import { _MMT_GRADE_RANGE, _MRS_RANGE } from '@/components/Table/static'
    export default {
        name: `PatientCondition`,
        props: [ 'patientTotalInfo' ],
        components: { KvTable },
        data() {
            return {}
        },
        method: {},
        computed: {
            getPatientStatus() {
              let strokeDuration = '';
              if (this.patientTotalInfo.patientInfo.patientInfoOccurrenceDate !== null) {
                const occurrenceDate = this.moment(this.patientTotalInfo.patientInfo.patientInfoOccurrenceDate);
                strokeDuration = this.moment().diff(occurrenceDate, "days");
              } else {
                strokeDuration = null;
              }

              let infection = this.patientTotalInfo.patientStatus.patientStatusInfection === 1 ? 'Y' : '-';
              infection = this.patientTotalInfo.patientStatus.patientStatusInfection !== 0 ? infection : 'N';

              return [
                {
                  index: 0,
                  keyTitle: this.$t('patient.condition.paralysis_part'),
                  keyType: 'Default',
                  class: [],
                  parentClass: ['columns_1-2'],
                  keyRange: [],
                  values: this.patientTotalInfo.patientStatus.patientStatusParalysisPart || '-'
                },
                {
                  index: 2,
                  keyTitle: this.$t('patient.condition.infection'),
                  keyType: 'Default',
                  class: [],
                  parentClass: '',
                  keyRange: [],
                  values: infection,
                },
                {
                  index: 3,
                  keyTitle: this.$t('unit.MMT.name'),
                  keyType: 'Default',
                  keyOption: {
                    tooltip: this.$t('unit.MMT.desc'),
                  },
                  class: [],
                  parentClass: '',
                  keyRange: [],
                  values: this.patientTotalInfo.patientStatus.patientStatusMMT === '' || this.patientTotalInfo.patientStatus.patientStatusMMT === undefined || this.patientTotalInfo.patientStatus.patientStatusMMT === null
                      ? 'N/A' : _MMT_GRADE_RANGE[Number(this.patientTotalInfo.patientStatus.patientStatusMMT) + 1].title
                },
                {
                  index: 4,
                  keyTitle: this.$t('unit.MRS.name'),
                  keyType: 'Default',
                  keyOption: {
                    tooltip: this.$t('unit.MRS.desc'),
                  },
                  class: [],
                  parentClass: '',
                  keyRange: [],
                  values: this.patientTotalInfo.patientStatus.patientStatusMRS === '' || this.patientTotalInfo.patientStatus.patientStatusMRS === undefined || this.patientTotalInfo.patientStatus.patientStatusMRS === null
                      ? 'N/A' : _MRS_RANGE[Number(this.patientTotalInfo.patientStatus.patientStatusMRS) + 1].title
                },
                {
                  index: 5,
                  keyTitle: this.$t('patient.condition.onset_period'),
                  keyType: 'Default',
                  class: [],
                  parentClass: '',
                  keyRange: [],
                  values: strokeDuration ? strokeDuration + this.$t('unit.days') : '-'
                },
                {
                  index: 6,
                  keyTitle: this.$t('patient.condition.medicine'),
                  keyType: 'Default',
                  class: [],
                  parentClass: ['columns_3-4'],
                  keyRange: [],
                  values: this.patientTotalInfo.patientStatus.patientStatusMedication ? this.patientTotalInfo.patientStatus.patientStatusMedication : '-'
                }
              ];
            }
        }
    }
</script>

<style lang="scss">

</style>